export const LOCALE: Record<string, TAvailableLocale> = {
  EN: "en",
  DE: "de",
  ES: "es",
  UK_UA: "uk-UA",
  PL: "pl",
  FR: "fr",
  FR_CA: "fr-CA",
  HE: "he",
  IT: "it",
  PT: "pt",
  CA: "ca",
  KO: "ko",
  ZH: "zh",
  BS_BA: "bs-BA",
} as const;
